import React from "react";
import Icon from "../../../atoms/icon/Icon";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import VerticalGroup from "../../../atoms/verticalgroup/VerticalGroup";
import RoundResultsContainer from "../components/RoundsResultsContainer";
import EditableReportingHeading from "../components/EditableReportingHeading";

interface Props {}

const RoundResultsLetsGo: React.FC<Props> = () => {
  return (
    <RoundResultsContainer>
      <VerticalGroup full center wide spaceBetweenElements={4}>
        <VerticalGroup spaceBetweenElements={2} center wide>
          <EditableReportingHeading defaultHeading="Let's Go" />
        </VerticalGroup>
        <InlineGroup block fullHeight verticalCenter center>
          <Icon
            type="lets_go"
            dynamicSize={{ min: "350px", preferred: "35vw", max: "1500px" }}
            skipSizing
          />
        </InlineGroup>
      </VerticalGroup>
    </RoundResultsContainer>
  );
};

export default RoundResultsLetsGo;
